/**
 * Filters the entries of a given Map based on a provided predicate function.
 *
 * This function iterates over the entries of the input Map and applies the
 * `filterFn` to each value. If the predicate returns `true`, the key-value
 * pair is included in the resulting Map.
 *
 * @param {Map<any, any>} inputMap - The original Map to filter.
 * @param {function(any): boolean} filterFn - A predicate function that takes
 *  a value from the Map and returns `true` to include the entry in the result,
 *  or `false` to exclude it.
 * @returns {Map<any, any>} - A new Map containing only the entries that pass
 *  the filter condition.
 */
const filterMap = (inputMap, filterFn) => {
  const filteredMap = new Map();
  for (const [key, value] of inputMap.entries()) {
    if (filterFn(value)) {
      filteredMap.set(key, value);
    }
  }

  return filteredMap;
};

export default filterMap;
